import RESET_PASSWORD from './resetPassword.gql';

export {
  // eslint-disable-next-line import/prefer-default-export
  RESET_PASSWORD,
};
